module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_03_770_280_en-16cfb6266f46dcb2c54408d45c952b85.jpg";